import {NavLink} from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {Button, Typography} from "@mui/material";
import {blue, grey} from "@mui/material/colors";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function CreateObjectButton({href, text, light = false, disabled = false, sx}: {
    href: string
    text: string
    light?: boolean
    disabled?: boolean
    sx?: any
}) {
    const {uiVisual} = useAppContext();

    const color = uiVisual === 'classic' ? grey[900] : blue[900];
    const block = {
        classic: {
            mr: 1,
            px: 1.75,
            height: 35.69,
            minWidth: 50,
            bgcolor: 'white',
            border: '1px solid #bdbdbd',
            borderRadius: 0,
            textTransform: 'unset',
            "&:hover": {
                bgcolor: grey[100]
            },
            "&:disabled": {
                opacity: 0.5
            },
        },
        modern: {
            mr: 1,
            px: 1.75,
            height: 35.69,
            minWidth: 50,
            bgcolor: light ? 'white' : '#ECF4FF',
            borderRadius: 1,
            textTransform: 'unset',
            "&:hover": {
                bgcolor: 'white'
            },
            "&:disabled": {
                opacity: 0.5
            },
        }
    }

    return (
        <Button disabled={disabled}
                size="small"
                variant="text"
                component={NavLink}
                to={href}
                startIcon={<AddOutlinedIcon sx={{color}}/>}
                sx={{...block[uiVisual], ...sx}}>
            <Typography
                component="span"
                fontSize={13}
                fontWeight={500}
                color={color}
                textTransform="unset">
                {text}
            </Typography>
        </Button>
    )
}